<template>
    <Modal modalType="loginModal" :removePadding="true" :narrow="false" :open="loginModal.show" :show-close-icon="true" @close="dismissModal" :is-card="true" :close-has-background="true">
        <div class="login-modal__container">
            <div class="login-modal__form">
                <ul v-if="errors && errors.length > 0" class="validation-error__ul ul__no-bullet">
                    <li v-for="error in errors" :key="error" class="validation-error__li validation-error--danger">{{ error }}</li>
                </ul>
                <div v-if="statusMessage" class="validation-error__ul ul__no-bullet">
                    <li class="validation-error__li validation-error--success">
                        {{ statusMessage }}
                    </li>
                </div>
                <div v-if="showForgotPassword === false">
                    <div class="login-modal__form-item">
                        <h1 class="login-modal__form-h1">Login to your account</h1>
                        <p v-if="loginModal.type === 'saved-vehicle'" class="login-modal__form-subheading">Save a vehicle to your account where you can revisit the vehicle at a time which suits you.</p>
                        <p v-else-if="loginModal.type === 'price-alert'" class="login-modal__form-subheading">Create a price alert to be notified when a vehicle you're interested in changes in price.</p>
                    </div>                      
                    <div class="login-modal__form-item">
                        <input v-model="form.email" type="email" data-validate="input"
                            data-validate-message="Please enter your email" name="email"
                            class="form-element__input" placeholder="Email address*">
                    </div>
                    <div class="login-modal__form-item">
                        <div class="login-modal__password-container">
                            <input v-model="form.password" class="form-element__input" :type="passwordFieldType" name="password" id="password" placeholder="Password*">
                            <span class="login-modal__toggle-password" @click="togglePasswordVisibility">
                                <img :src="eyeIcon" alt="Toggle Password" class="login-modal__eye-icon" id="eye-icon">
                            </span>
                        </div>
                    </div>
                    <div class="login-modal__form-item">
                        <a type="button" @keypress.enter="login" @click="login" class="btn btn--primary btn--full-width">Sign In</a>
                    </div>
                    <div class="login-modal__form-item">
                        <a href="" @click.prevent="toggleForgotPassword" class="login-modal__form-forgot">Forgot Password?</a> 
                    </div>
                </div>
                <div v-else>
                    <div class="login-modal__form-item">
                        <h1 class="login-modal__form-h1">Reset Password</h1>
                    </div>
                    <div class="login-modal__form-item">
                        <input v-model="form.email" type="text" data-validate="input"
                            data-validate-message="Please enter your email" name="email"
                            autocomplete="off" class="form-element__input" placeholder="Email address*">
                    </div>
                    <div class="login-modal__form-item">
                        <a @click="resetPassword" class="btn btn--primary btn--full-width">SEND PASSWORD REST LINK</a>
                    </div>
                    <div class="login-modal__form-item">
                        <a href="" @click.prevent="returnToLogin" class="login-modal__form-forgot">Return to login</a>
                    </div>
                </div>
                <div class="login-modal__form-create">
                    <h2 class="login-modal__form-h2">Don't have an account?</h2>
                    <div class="login-modal__form-item">
                        <button @click="register" class="btn btn--primary-inverted btn--full-width">CREATE AN ACCOUNT</button>
                    </div>
                </div>
            </div>
            <div class="login-modal__bg">
                <img src="/images/my-account/my-account-icon.svg" alt="" class="login-modal__my-account-icon" />
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from "../../core/components/Modal.vue";
import { mapState } from 'vuex';

export default {
    components: {
        Modal
    },

    data() {
        return {
            form:{
                email:null,
                password:null,
            },
            showPassword: false,
            showForgotPassword: false
        };
    },

    computed: {
        ...mapState("Auth", [
            'loginModal',
            'errors',
            'statusMessage'
        ]),
        hasErrors() {
            return this.errors.length > 0;
        },
        passwordFieldType() {
            return this.showPassword ? 'text' : 'password';
        },
        eyeIcon() {
            return this.showPassword ? '/images/my-account/eye-closed.svg' : '/images/my-account/eye-open.svg';
        }
    },

    methods: {
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        toggleForgotPassword(){
            this.showForgotPassword = true;
        },
        returnToLogin(){
            this.showForgotPassword = false;
        },
        login() {
             this.$store.dispatch('Auth/login', { email: this.form.email, password: this.form.password })
        },
        resetPassword() {
            this.$store.dispatch('Auth/resetPassword', { email: this.form.email }).then(this.showForgotPassword = false)
        },  
        dismissModal() {
            this.$store.commit('Auth/setPriceAlertUnauthenticated', false)
            this.$store.commit("Auth/setShowLoginModal", {
                show:false,
                type:'',
            });
        },
        register() {
            this.$store.dispatch('Layout/storeInSession')
        }
    },
};
</script>

<style lang="scss">
  @import "../../../sass/used/search-results";
  @import "../../../sass/used/search-results/login-modal";
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/LoginModal.vue